import StoreUtil from '@/store/StoreUtil'

export default {
  SET_IS_FETCHING: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setIsFetching'
  ),
  SET_IS_STARRED: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setIsStarred'
  ),
  SET_SCAN: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'setScan'),
  SET_TITLE: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.scan, 'setTitle'),
  SET_IS_EDITING_TITLE: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'isEditingTitle'
  ),
  SET_SCAN_DEFAULT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setScanDefault'
  ),
  SET_SHOW_UPDATE_FORM: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setShowUpdateForm'
  ),
  SET_SHOW_EDUCATION_FORM: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setShowEducationForm'
  ),
  SET_POWER_EDIT_DATA: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setPowerEditData'
  ),
  SET_OPPORTUNITY_ID: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setOpportunityId'
  ),
  SET_CV_TEXT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setCvText'
  ),
  SET_JD_TEXT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setJdText'
  ),
  SET_CL_TEXT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setClText'
  ),
  SET_CONVERSION_ID: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setConversionId'
  ),
  SET_CL_CONVERSION_ID: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.scan,
    'setClConversionId'
  ),
}
